import CollapsibleInfoBar from "./CollapsibleInfoBar";

export default CollapsibleInfoBar;
